import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import {
  useGetProductDetailsQuery,
  useUpdateProductMutation,
  useUploadProductImagesMutation,
} from '../../slices/productsApiSlice';

const ProductStaffEditScreen = () => {
  const { id: productId } = useParams();

  const [name, setName] = useState('');
  const [price, setPrice] = useState(0);
  const [images, setImages] = useState([]); // Updated to handle multiple images
  const [brand, setBrand] = useState('');
  const [category, setCategory] = useState('');
  const [countInStock, setCountInStock] = useState(0);
  const [description, setDescription] = useState('');

  const {
    data: product,
    isLoading,
    refetch,
    error,
  } = useGetProductDetailsQuery(productId);

  const [updateProduct, { isLoading: loadingUpdate }] =
    useUpdateProductMutation();

  const [uploadProductImages, { isLoading: loadingUpload }] =
    useUploadProductImagesMutation();

  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await updateProduct({
        productId,
        name,
        price,
        images, // Use the array of image URLs
        brand,
        category,
        description,
        countInStock,
      }).unwrap();
      toast.success('Product updated');
      refetch();
      navigate('/productlist');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  useEffect(() => {
    if (product) {
      setName(product.name);
      setPrice(product.price);
      setImages(product.images || []); // Initialize with images array
      setBrand(product.brand);
      setCategory(product.category);
      setCountInStock(product.countInStock);
      setDescription(product.description);
    }
  }, [product]);

  const uploadFileHandler = async (e) => {
    const formData = new FormData();
    for (let i = 0; i < e.target.files.length; i++) {
      formData.append('images', e.target.files[i]); // Append multiple images
    }
    try {
      const res = await uploadProductImages(formData).unwrap();
      toast.success(res.message);
      setImages(res.images); // Update the images state with the returned URLs
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <>
      <Link to='/productlist' className='btn btn-light my-3'>
        Go Back
      </Link>
      <FormContainer>
        <h1>Edit Product</h1>
        {loadingUpdate && <Loader />}
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant='danger'>{error.data.message}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
            <Form.Group controlId='name'>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type='name'
                placeholder='Enter name'
                value={name}
                onChange={(e) => setName(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='price'>
              <Form.Label>Price</Form.Label>
              <Form.Control
                type='number'
                placeholder='Enter price'
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='images'>
              <Form.Label>Images</Form.Label>
              <Form.Control
                type='file'
                multiple // Allow multiple files
                onChange={uploadFileHandler}
              ></Form.Control>
              {loadingUpload && <Loader />}
              {images.length > 0 && (
                <div>
                  <h6>Uploaded Images:</h6>
                  <ul>
                    {images.map((img, index) => (
                      <li key={index}>
                        <a href={img} target='_blank' rel='noreferrer'>
                          {img}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </Form.Group>
               <div className='mt-3'>
                 <h6>Uploaded Images:</h6>
                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                   {images.map((img, index) => (
                     <div key={index} style={{ position: 'relative' }}>
                       <img
                         src={img}
                         alt={`Uploaded ${index + 1}`}
                         style={{
                           width: '100px',
                           height: '100px',
                           objectFit: 'cover',
                           borderRadius: '5px',
                         }}
                       />
                       <button
                         type="button"
                         onClick={() =>
                           setImages((prevImages) => prevImages.filter((_, i) => i !== index))
                         }
                         style={{
                           position: 'absolute',
                           top: '-6px',
                           right: '-6px',
                           background: '#dc3545',
                           color: '#fff',
                           border: 'none',
                           borderRadius: '50%',
                           width: '20px',
                           height: '20px',
                           fontSize: '14px',
                           cursor: 'pointer',
                         }}
                       >
                         ×
                       </button>
                     </div>
                   ))}
                        </div>
                        </div>
             
            
            <Form.Group controlId='brand'>
              <Form.Label>Type</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter brand'
                value={brand}
                onChange={(e) => setBrand(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='countInStock'>
              <Form.Label>Count In Stock</Form.Label>
              <Form.Control
                type='number'
                placeholder='Enter countInStock'
                value={countInStock}
                onChange={(e) => setCountInStock(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='category'>
              <Form.Label>Category</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter category'
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='description'>
              <Form.Label>Description</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter description'
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Button
              type='submit'
              variant='primary'
              style={{ marginTop: '1rem' }}
            >
              Update
            </Button>
          </Form>
        )}
      </FormContainer>
    </>
  );
};

export default ProductStaffEditScreen;